export const SeaStory = {
    level: 11,
    name: 'Sea adventures',
    cpu1Name: 'Nia the Navigator',
    cpu2Name: 'Elva the Healer',
    cpu3Name: 'Rynn the Gunner',
    text: 'What could be better than the fresh sea breeze—only new adventures.',
    classCss: 'map-sea-adv-ico',
    cpu1: {
        id: 31,
        before: {
            type: 'comics',
            comicsSetting: {
                path: './img/stories/sea_adv/intro/',
                slideNumber: 23
            }
        },
        after: {
            player: {
                type: 'text',
                step: {
                    0: "The first key is here!",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'We need more rum! The sailors won’t be able to climb the masts if they get drunk.',
                }
            }
        }
    },
    cpu2: {
        id: 32,
        before: {
            type: 'text',
            step: {
                0: "Oh, Elva, how many unforgettable nights we’ve spent together — it’s a pity you’re so jealous…",
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "Wow, the second key! I'm starting to get excited — one more and my pussy will be free!",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'We need less rum…',
                }
            }
        }
    },
    cpu3: {
        id: 33,
        before: {
            type: 'text',
            step: {
                0: "Rynn is hot not only in bed — she’s pure fire, an explosion, and unfortunately often deadly for those who cross her path.",
            }
        },
        after: {
            cpu: {
                type: 'text',
                step: {
                    0: "Hmm… Rest, think; defeating Rynn is possible, but it requires a special approach.",
                }
            },
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/sea_adv/win/',
                    slideNumber: 19,
                    animatedSlides: [11,12]
                }
            }
        },
    },
    cpu4: {
        id: 44,
        before: {
            type: 'text',
            step: {
                0: 'Prepare to board! All hands on deck!',
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: 'An honest victory! We should compose a heroic ballad so it’s sung in every port tavern. <i>Sings</i> “On one gloomy day, evil thieves tried to board the ship of a brave hero…”',
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Well, we lost a bit. But what a fight it was! Steel rang, gunshots echoed! Just the way I like it!',
                }
            }
        }
    },
}
